import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageComponent } from '../image/image.component';
import { FormatUrlPipe } from "@/shared/components/image/pipes/format-url.pipe";

@NgModule({
  declarations: [
    ImageComponent,
    FormatUrlPipe,
  ],
  imports: [
    CommonModule,
  ],
  exports: [ImageComponent],
})
export class ImageModule { }
